import { render } from "./SelecionarEstruturaDRE.vue?vue&type=template&id=98ed02ae&scoped=true&ts=true"
import script from "./SelecionarEstruturaDRE.vue?vue&type=script&lang=ts"
export * from "./SelecionarEstruturaDRE.vue?vue&type=script&lang=ts"

import "./SelecionarEstruturaDRE.vue?vue&type=style&index=0&id=98ed02ae&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98ed02ae"]])

export default __exports__